import React from 'react';

const CanceledDeliveriesStatus = ({ document }) => {
    const deliveries_returns = document.deliveries_returns || [];

    let classColor = (deliveries_returns.length > 0) ? 'c-red' : '';

    return (
        <div className={`label-icon ${classColor}`}>
            <i className="material-icons">settings_backup_restore</i>
            {deliveries_returns.length}
        </div>
    );
}

CanceledDeliveriesStatus.defaultProps = {
    document: {}
};

export default CanceledDeliveriesStatus;



// WEBPACK FOOTER //
// ./src/components/Status/CanceledDeliveries.js